module.exports = __webpack_public_path__ + "static/media/r5-d4.c27cbd09.jpg";